import { Container, Form, Alert} from 'react-bootstrap';
import {Sida,Rubrik,ContentWrapper, Button} from "../ContentStyles";
import useBackend, {CallAPI, Loading, Spinner, UserData} from '../../services/useBackend';
import React, { useState ,useEffect, useReducer, fetchData,useMemo} from 'react';
import {DateTimeToLocal, MultiselectGetOptions, MultiselectGetDefaultValues, escapedNewLineToLineBreakTag, ConcatLocalDateAndTime2ISO, SplitoutLocalDateFromISO, SplitoutLocalTimeFromISO, getOptions, metaLookUpTitle} from '../../services/misc';

function PasswordChange() {
    const [resultText, setResultText] = useState("N/A");
    const [resultVariant, setResultVariant] = useState("success");
    const [resultVisible, setResultVisible] = useState(false);
    const [spinnerHidden, setSpinnerHidden] = useState(true);    

    const {IsLoggedIn, token}      = UserData();

    async function handleSubmit(e) {
        e.preventDefault();
        setSpinnerHidden(false);

        const formData = new FormData(e.target),
        formDataObj = Object.fromEntries(formData.entries())

        let {resultVariant, errorsException, resultVisible, resultText, jsondata} = await CallAPI('/api/user','PATCH',JSON.stringify(formDataObj));

        setResultVariant(resultVariant);      
        setResultText(resultText);        
        setSpinnerHidden(true);
        setResultVisible(resultVisible);
    }   

    return (
        <ContentWrapper>
                <Sida>
                <Rubrik>Byt lösenord</Rubrik>

                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>Password</Form.Label>
                        <Form.Control type="password" name="Password" placeholder="password" id="password1" defaultValue=""/>
                    </Form.Group>    

                    <Form.Group className="mb-3" >
                        <Form.Label>Password</Form.Label>
                        <Form.Control type="password" name="Password_validate" placeholder="password" id="password1" defaultValue="" />
                    </Form.Group>                                              

                    <Form.Group className="mb-3"  hidden={spinnerHidden}>
                        <Spinner  />
                    </Form.Group>                     

                    <Form.Group className="mb-3"  hidden={!resultVisible}>
                        <Alert show={resultVisible} variant={resultVariant}  className="FormSpace">{resultText}</Alert> 
                    </Form.Group>        

                    <Form.Group className="mb-3">
                        <Button className="QmeButton" variant="primary" type="submit">Spara</Button>
                    </Form.Group>    
                </Form>      
            </Sida>
        </ContentWrapper>
    );   
}

export default PasswordChange;